import { AuthGuard } from '../../../../../common/services/Auth.guard';
import { SwitchboardComponent } from './switchboard.component';
import { IvrComponent } from './ivr/ivr.component';
import { QueueComponent } from './queue/queue.component';
import { SipTrunkComponent } from './siptrunk/sip-trunk.component';
import { ScriptComponent } from './ivr/script/script.component';
import { AudioComponent } from './ivr/audio/audio.component';

export const SwitchboardSettingsRoute = [
  {
    path: 'switchboard',
    component: SwitchboardComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'ivr', pathMatch: 'full' },
      {
        path: 'ivr',
        component: IvrComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', redirectTo: 'script', pathMatch: 'full' },
          {
            path: 'script',
            component: ScriptComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'audio',
            component: AudioComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
      { path: 'queue', component: QueueComponent, canActivate: [AuthGuard] },
      // {path: 'sip-trunk', component: SipTrunkComponent, canActivate: [AuthGuard]},
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/switchboard/switchboard.route.ts